import './SubMenu2.scss';
import * as React from 'react';
import * as classNames from "classnames";
import { Link } from "../../routing/index";
import { INavItem } from "../NavMenu/NavMenu";
import { InlineLoading } from "../../common/index";
interface ISubMenu2Props {
  subMenuTitle?: string;
  items: INavItem[];
  loading?: boolean;
  fullWidth?: boolean;
}
class SubMenu2 extends React.PureComponent<ISubMenu2Props, any> {
  constructor(props) {
    super(props);
  }
  componentWillMount() {}
  componentWillReceiveProps(nextProps: any) {}
  componentDidUpdate(prevProps: any) {}
  componentWillUpdate(nextProps: any) {}
  componentWillUnmount() {}
  render() {
    const {
      subMenuTitle,
      items,
      loading,
      fullWidth
    } = this.props;
    return <div className={`${fullWidth ? 'container-fluid' : 'container'} p-0 box-shadow-x`} data-sentry-component="SubMenu2" data-sentry-source-file="SubMenu2.tsx">
            {subMenuTitle && <div className={classNames(fullWidth ? 'container-fluid' : 'container', "p-0", "d-flex", "sub-menu-2-header", "Capture-menu", "x-box-shadow-x")}><label className={"sub-menu-2-title"}>{subMenuTitle}</label></div>}
            <nav className={classNames(fullWidth ? 'container-fluid' : 'container', "p-0", "d-flex", "Tmd-menu-2", "x-box-shadow-x", {
        "justify-content-around": loading
      })}>
                {loading ? <InlineLoading className="my-1" size={32}></InlineLoading> : items && items.length > 0 ? items.map(this.createItem) : null}
            </nav>
        </div>;
  }
  createItem(item: INavItem, index: number, items: INavItem[]): React.ReactNode {
    return item.url ? <Link key={"sub-menu-2-" + index} className={classNames("nav-link", {
      "nav-link-current": item.current
    })} activeClassName={"nav-link-current"} url={item.url} target={item.target}>
                {item.icon}
                {item.icon && <span>&emsp;</span>}
                <span>
                    {item.title}
                </span>
            </Link> : <a key={"sub-menu-2-" + index} className="nav-link">
                {item.icon}
                {item.icon && <span>&emsp;</span>}
                <span>
                    {item.title}
                </span>
            </a>;
  }
}
export default SubMenu2;